import type { PitchDigestKind, PitchStatus } from "../../shared/types";

export type PitchDigestAction = PitchDigestKind | "clearDigest";

export type PitchDigestStamp =
    | { status: PitchStatus; digestKind: PitchDigestKind }
    | { status: "pitched"; clearDigest: true };

const STATUS_FROM_DIGEST_KIND: Record<PitchDigestKind, PitchStatus> = {
    new: "pitched",
    updated: "pitched",
    withdrawn: "withdrawn",
    accepted: "approved",
    rejected: "rejected",
};

export function getStatusFromDigestKind(kind: PitchDigestKind): PitchStatus {
    return STATUS_FROM_DIGEST_KIND[kind];
}

/** Status plus digestKind for a pitch write. Unreject is `clearDigest`: pitched, and digest fields must be deleted. */
export function pitchDigestFields(action: PitchDigestAction): PitchDigestStamp {
    if (action === "clearDigest") {
        return { status: "pitched", clearDigest: true };
    }
    return { status: getStatusFromDigestKind(action), digestKind: action };
}
